module.exports = __webpack_public_path__ + "img/pptbg.6d9a6839.png";